import Box from "@material-ui/core/Box";
import React from "react";

// 診断結果の送信が401（セッション切れ）で失敗した際に表示する永続的な案内。
// 再試行しても成功しないため、通常のスナックバー（数秒で消える）ではなく
// src/utilities/NotifyNetworkError.tsx の NotifyNetworkError に渡す ErrorMessage として使い、
// ユーザーが手動で閉じるまで表示し続ける。
export const DiagnosisSubmitSessionExpiredMessage: React.FC = () => (
  <Box mt={-2}>
    セッションが切れているため、診断結果を送信できません。
    <br />
    画面をリロードし、再度ログインしてください。
  </Box>
);
